import React from "react";
import HeaderWithSearch from "./HeaderWithSearch";
import ImageWithFallback from "./ImageWithFallback";

function VanillaIceCream() {
  return (
    <>
      <HeaderWithSearch />
      <main
        style={{
          minHeight: "100vh",
          width: "100%",
          background: "linear-gradient(180deg, #e3f0fc 0%, #fafdff 100%)",
          padding: 0,
          margin: 0,
        }}
      >
        <section
          className="recipe-hero-anim"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "60vh",
            padding: "60px 20px 40px 20px",
          }}
        >
          <h1
            className="recipe-title-anim"
            style={{
              fontSize: "3rem",
              fontWeight: "bold",
              marginBottom: 16,
              textAlign: "center",
            }}
          >
            Vanilla Ice Cream
          </h1>
          <span className="season-badge season-summer" style={{ marginBottom: 24 }}>☀️ Best in Summer</span>
          <ImageWithFallback
            src="/vanilla_ice_cream.jpg"
            alt="Vanilla Ice Cream"
            className="recipe-image-anim"
            style={{
              width: 400,
              height: 300,
              objectFit: "cover",
              borderRadius: 24,
              boxShadow: "0 4px 32px rgba(0,0,0,0.10)",
              marginBottom: 32,
            }}
          />
          <div
            style={{
              maxWidth: 800,
              fontSize: "1.1rem",
              color: "#333",
              lineHeight: 1.8,
            }}
          >
            <h2 style={{ fontSize: "1.5rem", fontWeight: 600, marginBottom: 16 }}>
              Ingredients:
            </h2>
            <ul className="ingredient-list" style={{ marginBottom: 24, paddingLeft: 20 }}>
              <li>2 cups heavy cream</li>
              <li>1 cup whole milk</li>
              <li>3/4 cup granulated sugar</li>
              <li>2 tsp pure vanilla extract (or 1 vanilla bean)</li>
              <li>Pinch of salt</li>
            </ul>

            <h2 style={{ fontSize: "1.5rem", fontWeight: 600, marginBottom: 16 }}>
              Instructions:
            </h2>
            <ol className="instructions-list" style={{ paddingLeft: 20, marginBottom: 24 }}>
              <li style={{ marginBottom: 12 }}>
                <strong>Mix ingredients:</strong> In a medium bowl, whisk together the heavy cream, whole milk, sugar, vanilla extract, and salt until the sugar is completely dissolved (about 2-3 minutes).
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Chill mixture:</strong> Cover the bowl and refrigerate for at least 2 hours, or overnight for best results. The mixture should be very cold before churning.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Churn:</strong> Pour the chilled mixture into your ice cream maker and churn according to the manufacturer's instructions (typically 20-25 minutes) until it reaches a soft-serve consistency.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Freeze:</strong> Transfer the ice cream to an airtight container and freeze for at least 4-6 hours until firm before serving.
              </li>
            </ol>

            <div
              className="chef-tips-box"
              style={{
                background: "#f8f9fa",
                padding: 20,
                borderRadius: 12,
                marginTop: 24,
              }}
            >
              <h3 style={{ fontSize: "1.3rem", fontWeight: 600, marginBottom: 12 }}>
                <span className="tip-icon" role="img" aria-label="chef">👨‍🍳</span> Chef's Tips:
              </h3>
              <ul style={{ paddingLeft: 20 }}>
                <li>Use high-quality vanilla extract or vanilla bean for the best flavor</li>
                <li>Make sure all ingredients are very cold before churning for creamier texture</li>
                <li>Let ice cream sit at room temperature 5-10 minutes before scooping</li>
                <li>Add mix-ins (chocolate chips, cookie pieces, fruit) during the last 2 minutes of churning</li>
                <li>Store in an airtight container to prevent ice crystals</li>
                <li>Homemade ice cream is best consumed within 2 weeks</li>
              </ul>
            </div>

            <div
              className="health-benefits-box"
              style={{
                background: "#eef9f0",
                padding: 20,
                borderRadius: 12,
                marginTop: 24,
              }}
            >
              <h3 style={{ fontSize: "1.3rem", fontWeight: 600, marginBottom: 12 }}>
                <span className="tip-icon" role="img" aria-label="health">🌿</span> Health Benefits
              </h3>
              <ul style={{ paddingLeft: 20 }}>
                <li>Made from real cream and milk, it provides calcium for bone health.</li>
                <li>Homemade ice cream skips the stabilizers and artificial additives in many store-bought tubs.</li>
                <li>A cold, sweet treat like this can help cool the body down on hot days.</li>
                <li>Enjoying it in moderation as an occasional treat fits well into a balanced diet.</li>
              </ul>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default VanillaIceCream;